import React, { useEffect, useMemo } from 'react'
import { useLocation, Outlet } from "react-router-dom";
import styled from "styled-components";
import NavBar from './NavBar/index'
import { useAccount } from 'wagmi'
import Nav from "@/components/Nav/index";
import SwitchNetWork from "../components/SwitchNetWork/Modal";
import { useWhiteList } from '../hooks/index.js'
import { useState } from 'react';
import { ToastProvider } from '../contexts/ToastContext.js';
import { useNetwork } from 'wagmi'
import { chainId } from "@/utils/abi";
import HomeBg from '../assets/imgs/home_bg.png'

export default function Layout() {

  const { chain } = useNetwork()
  const { isConnected } = useAccount();
  const [isOpen, setIsOpen] = useState(!false)
  const [isOpen2, setIsOpe2] = useState(false)
  const isWhiteList = useWhiteList()
  const location = useLocation();

  const isOpen2Copy = useMemo(() => (chain?.id !== chainId && isConnected), [chain, location])
  
  return (
    <ToastProvider>
      <PageWrapper>        
        <img className='home-bg' src={HomeBg} alt="" loading="lazy" />
        <NavBar></NavBar>
        {/* {
          isConnected && !isWhiteList &&  <WhiteListModal isOpen={isOpen} handleClose={() => setIsOpen(false)}/>
        } */}
        <div className='main-content'>
          <Outlet />
        </div>
        <div className='nav-wrapper'>
          <Nav/>
        </div>
      </PageWrapper>
      {isOpen2Copy && <SwitchNetWork isOpen={isOpen2Copy} handleClose={() => setIsOpe2(false)}/>  }
    </ToastProvider>
  )
}

const PageWrapper = styled.div`  
  position: relative;
  min-height: 100vh;
  @media only screen and (max-width: 1390px) {
    .nav-wrapper {
      display: none;
    }
  }
  
  .home-bg{
    min-width: 1440px;  
    width: 100%;
    z-index: -1;
    position: absolute;
    top: 0;
    left: 0;
  }
  .main-content{
    
  }
  .side-bar{
    min-width: 205px;    
    display: flex;
    flex-direction: column;
    padding-bottom:44px;
  }
  .nav-wrapper{
    position: absolute;
    top: 260px;
    right: 0;
  }
`